import { render } from "./account-group-list-item.vue?vue&type=template&id=31275532&scoped=true"
import script from "./account-group-list-item.vue?vue&type=script&lang=js"
export * from "./account-group-list-item.vue?vue&type=script&lang=js"

import "./account-group-list-item.vue?vue&type=style&index=0&id=31275532&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31275532"]])

export default __exports__